import { useTheme } from '@flik/shared/components';
import React from 'react';
import MagicModal from '../magic/components/MagicModal';

const NotFoundPage: React.FC = () => {
  const { provideTailwind } = useTheme();

  return (
    <div className={`w-full min-h-screen ${provideTailwind('bg-primary')}`}>
      <MagicModal initialAction="not-found" initialHasResults={true} />
    </div>
  );
};

export default NotFoundPage;
